import useSelectedFigureItems from "./useSelectedFigureItems";
import RegionSpecificMenu from './RegionSpecificMenu';
import { useStore } from 'react-redux';
import { useFigurePanelId } from './FigurePanelIdProvider';
import LineStyleIcon from '@material-ui/icons/LineStyle';
import LineWeightIcon from '@material-ui/icons/LineWeight';

import G from './Getters';
/*

  1. parent regions 
    ==> we're showing options to show/hide all of the regions inside main
    Hence, we need to just get the data for the nodes and display them.

    What's needed is:
      The cell location to get info about the subregions selected...

  2. zoom/inset region
    ==> same thing, we're selecting multiple of SINGLE
      ==> only displaying options for a unified group

  3. regionOutline
    ==> we may have many region outlines from many different cells
      ==> we're only displaying edit options for the one.

*/


function OutlineList({targetLists,byChildSubregions,applyToAll, onEvent, data,dataByRegion}){

  let store = useStore();
  let figurePanelId = useFigurePanelId();

  if( targetLists ){

    return targetLists.slice(0,1).map((targetList,ii) => {
      return (
        <RegionSpecificMenu key={ii} {...{
          regionId:ii,
          onEvent,
          data:dataByRegion[ii],
        }}/>
      )
    })
  }else if( byChildSubregions ){

    let childSubregionGroup = Object.entries(byChildSubregions);


    return childSubregionGroup.map(([regionId,targetList]) => {

      let state = store.getState();
      let data = G.getUnifiedGroupFromNodeValues(state,{
        figurePanelId,
        nodeDataList:targetList
      });

      return (
        <RegionSpecificMenu key={regionId} {...{
          regionId,
          targetLocations:targetList,
          onEvent,
          data,
        }}/>

      )
    })


  }else if( applyToAll ){
    return (
      <div>
        <div>{JSON.stringify(applyToAll)}</div>
        <div>{JSON.stringify(applyToAll)}</div>
      </div>
    )
  }else{
    return null;
  }


}



export default function SubregionOutlineMenu({
  data,args,onEvent,
}){

  let { 
    targetLists,
    byChildSubregions,
    applyToAll
  } = args || {};

  const selectedFigureItems = useSelectedFigureItems();
  const figurePanelId = useFigurePanelId();

  const store = useStore();
  const state = store.getState();
  let { expansionNodes } = selectedFigureItems;


  let values = expansionNodes?.map(item => ({nodeId:item.nodeId,...G.getEvaluatedFigurePanelCellNodeValue(state,{nodeId:item.nodeId, cellLocation:item.cellLocation,figurePanelId})}))



  return (


    <div class="full-width small-padding">
      {false && <div>
        <pre>
        {JSON.stringify(selectedFigureItems,null,1)}
        </pre>
      </div>}

      <table>
        <tr>
          <td style={{paddingRight:5}}>Box</td>
          <td style={{paddingRight:5}}>Lines</td>
          
          {false && <td style={{width:'100%'}}></td>}


                    
          <td><LineWeightIcon/></td>
          <td style={{
            paddingLeft:3
          }}><LineStyleIcon/></td>
          <td>Color</td>
          {false && <td>Radius</td>}
        </tr>


        <OutlineList 
          targetLists={targetLists||selectedFigureItems.expansionNodes}
          byChildSubregions={byChildSubregions}
          applyToAll={applyToAll}
          onEvent={onEvent}
          data={data}
          dataByRegion={values}
        />


        

      </table>
            
    </div>

  )

}
